import * as React from 'react';

import {
  PermissionsContext,
  type PermissionsContextValue,
} from '../../PermissionsProvider.types';

/**
 * Hook to access permissions context
 * Provides permissions data and helper functions for permission checking
 *
 * @returns PermissionsContextValue containing permissions, loading states, and hasPermission helper
 * @throws Error if used outside PermissionsProvider
 *
 * @example
 * const { permissions, hasPermission, isLoading } = usePermissions();
 * if (hasPermission('view_dashboard')) {
 *   // Show dashboard
 * }
 */
export function usePermissions(): PermissionsContextValue {
  const context = React.useContext(PermissionsContext);
  if (!context) {
    throw new Error('usePermissions must be used within PermissionsProvider');
  }

  return context;
}
